export const environment = {
  production: false,
  defaultauth: 'localhost',
  backend: 'https://api.nikki-staging.nl/api/',
  env: 'staging',
  name: 'NIKKI',
  locale: "en",

  portal: "https://portal.nikki-staging.nl",
  contributie: "https://contributie.nikki-staging.nl",
  client: "https://klant.nikki-staging.nl",

  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "" 
  },
  sentry: {
    dsn: 'https://0fec959aa08961004966baf548f9a506@o4507735602298880.ingest.de.sentry.io/4508595403948112',
    environment: 'staging'
  }
};